// Availability statuses (uppercased) of products that cannot be added to the cart
export const UNAVAILABLE_AVAILABILITY_STATUSES = [
  'DELAYED',
  'AVAILABLE_SOON',
  'AVAILABLE_ON_REQUEST',
  'OUT_OF_STOCK',
  'NOT_AVAILABLE',
  'NOTAVAILABLE',
  '2TO4WEEKS',
];
